// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;The Lord will grant his loving-kindness in the daytime;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;through the night his song will be with me,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a prayer to the God of my life.<br> </p> </div></div>";
// Exports
module.exports = code;